const Start = [
  {
    heroTitle: "Invite friends",
    subTitle:
      'How can we participate in the "coinnik Market" fee by inviting our friends to the coinnik Market profit?',
    body: [
      "Enter the friends invitation section from the panel menu.",
      "In this section, you can copy the referral token or the invitation link of your friends.",
      "Give it to your friends to enter your referral token in the invitation code section when registering.",
      "Or send them your referral link so that by clicking on this link, they will enter the registration page and the invitation code section will be filled in for them automatically",
    ],
    content:
      "Now you can receive 30% of the individual exchange fee that you have registered through your link.",
    firstContent: "Profit_from_inviting_friends",
    video: "https://www.aparat.com/video/video/embed/videohash/E4mJB/vt/frame",
  },
  {
    heroTitle: "Security setting",
    subTitle:
      'How in "coinnik Market" we can take care of your account information with the appropriate security settings.',
    content:
      "By activating the security items of your user account, you can ease your mind that no one but your person has access to your account.",
    body: [
      "From the panel menu, enter the settings section and then enter the security section.",
      "In this section, you can activate your two-factor login.",
      "You can enable login with Google Authenticator. To do this, just install the application on your mobile phone or use its Extension for Chrome, for example.",
      "Enter your personal key in it or scan the QR code displayed on the security screen.",
      "Now, for each login, enter the code that Google Authenticator generates for you temporarily and once, after entering the username and password.",
      "SMS_authentication",
    ],
    firstContent: "Your_security_settings",
    video: "https://www.aparat.com/video/video/embed/videohash/E4mJB/vt/frame",
  },
  {
    heroTitle: "Support section",
    subTitle: "How can we contact support at Kevin Nick Market?",
    content: "Your_message",
    body: [
      "Enter the support section from the menu panel.",
      "In this section, you can share your problems with us by registering a new ticket.",
      "In the pop-up that opens for you, you can send the desired department, the title and text of the message along with the attached file and image to our supporters.",
      "Tickets are answered in the shortest possible time and are available 24 hours a day, seven days a week, even on holidays.",
      "In addition to the ticket, you can communicate with us through online chat.",
    ],
    firstContent: "Your_ticket",
    video: "https://www.aparat.com/video/video/embed/videohash/2lHSK/vt/frame",
  },
];
export default Start;
